import type { LauncherPosition } from '@teo/widget-shared';
import { MOBILE_BREAKPOINT_PX } from '@teo/widget-shared';

export type Point = { x: number; y: number };
export type LauncherRect = { x: number; y: number; w: number; h: number };
export type Edge = 'left' | 'right';

export function viewportSize(): { w: number; h: number } {
  if (typeof window === 'undefined') return { w: 390, h: 844 };
  return {
    w: window.visualViewport?.width ?? window.innerWidth,
    h: window.visualViewport?.height ?? window.innerHeight,
  };
}

export function clamp(n: number, min: number, max: number): number {
  return Math.min(max, Math.max(min, n));
}

export function edgeFromPosition(position: LauncherPosition): Edge {
  return position.endsWith('_left') ? 'left' : 'right';
}

export function isTopPosition(position: LauncherPosition): boolean {
  return position.startsWith('top_');
}

/** Default FAB corner from BS_POSITIONING + offsets. */
export function expandedLauncherPos(
  position: LauncherPosition,
  sizePx: number,
  offsetX: number,
  offsetY: number,
): Point {
  const { w, h } = viewportSize();
  const x =
    edgeFromPosition(position) === 'left'
      ? offsetX
      : w - sizePx - offsetX;
  const y = isTopPosition(position) ? offsetY : h - sizePx - offsetY;
  return { x, y };
}

export function isMobileViewport(
  breakpointPx: number = MOBILE_BREAKPOINT_PX,
): boolean {
  if (typeof window === 'undefined') return false;
  return (
    window.matchMedia(
      `(max-width: ${breakpointPx}px), (max-height: 500px) and (pointer: coarse)`,
    ).matches
  );
}

/** Stable short key fragment for localStorage (not crypto). */
export function originStorageSuffix(): string {
  try {
    const origin = window.location.origin || 'local';
    let hash = 0;
    for (let i = 0; i < origin.length; i += 1) {
      hash = (hash * 31 + origin.charCodeAt(i)) | 0;
    }
    return Math.abs(hash).toString(36);
  } catch {
    return 'local';
  }
}

export const DRAG_STORAGE_PREFIX = 'teo_launcher_drag_';
export const EDGE_STORAGE_PREFIX = 'teo_launcher_edge_';
